import React from 'react';
import tw from 'twin.macro';
import styled from '@emotion/styled';

interface Props {
  children: React.ReactNode;
  onClick?: any;
  outside?: boolean;
}

const NoRadiusButtons = styled.div`
  .tsh-button {
    border-radius: 0;
  }
`;

export default function HoverActionsWrapper(props: Props) {
  const { children, onClick, outside = true } = props;
  return (
    <div
      role="presentation"
      data-testid="action-wrapper"
      onClick={onClick}
      css={[
        // Opacity plutot que visibility à cause des tests
        // On utilise z-19 pour être au dessus des autres éléments sans être au dessus du UserProfileMenu (z-20)
        tw`absolute right-0 bottom-0 transform z-[19] group-hover:visible invisible`,
        outside && tw`translate-y-2/3`,
      ]}
    >
      <NoRadiusButtons tw="flex flex-wrap justify-end rounded bg-neutral-supershy bg-opacity-70 overflow-hidden">
        {children}
      </NoRadiusButtons>
    </div>
  );
}
